
import { Component, Vue } from 'vue-property-decorator';
import { EliotModule } from '~/store/modules/eliot';
import DeviceData from '~/components/Data.vue';
import Users from '~/components/Eliot/Users.vue';
import ModulesList from '~/components/Eliot/ModulesList.vue';
import ChildrenList from '~/components/Eliot/ChildrenList.vue';
import EliotDevice from '~/components/Eliot/Device.vue';

@Component({
    components: {
        DeviceData,
        Users,
        ModulesList,
        ChildrenList,
        EliotDevice,
    },
})
export default class EliotGatewayView extends Vue {

    get currentGateway() {
        return EliotModule.currentGateway;
    }

    get currentModule() {
        return EliotModule.currentModule;
    }

    get gatewayData() {
        return EliotModule.deviceSpecFields(this.currentGateway);
    }

    get currentGatewayModules() {
        return EliotModule.currentGatewayModules;
    }

    get hasModules() {
        return this.currentGatewayModules.length > 0;
    }

    get currentGatewayChildren() {
        return EliotModule.currentGatewayChildren;
    }

    get hasChildren() {
        return this.currentGatewayChildren.length > 0;
    }

    get networkData() {
        return EliotModule.deviceNetworkFields(this.currentGateway);
    }

    get allowedUsersGateway() {
        return this.currentGateway?.allowedUsers;
    }

    get invitedUsersGateway() {
        return this.currentGateway?.invitedUsers;
    }


    get allowedUsersModule() {
        return this.currentModule?.allowedUsers;
    }
    get invitedUsersModule() {
        return this.currentModule?.invitedUsers;
    }

    get moduleData() {
        return EliotModule.deviceSpecFields(this.currentModule);
    }
    get moduleNetworkData() {
        return EliotModule.deviceNetworkFields(this.currentModule);
    }
}
